import { isNil } from '@flowio/is';
import createInlineCallbackListener from './create-inline-callback-listener';
export default function fiserveThreedsChallenge(action, container) {
  if (isNil(container)) {
    // eslint-disable-next-line no-console
    console.error('fiserveThreedsChallenge: Mounting container was not set.');
  }

  var callbackPromise = createInlineCallbackListener({
    expiresAt: action.expires_at
  });
  var iframe = document.createElement('iframe');
  iframe.id = 'fiserveTdsFrame';
  iframe.name = 'fiserveTdsFrame'; // eslint-disable-next-line no-script-url

  iframe.src = 'javascript:false;';
  iframe.style.border = 'none';
  iframe.style.width = '100%';
  iframe.style.height = '100%';
  iframe.style.minHeight = '400px';
  var form = document.createElement('form');
  form.action = action.threeds_challenge_action.acs_url;
  form.target = 'fiserveTdsFrame';
  form.id = 'fiserveTdsForm';
  form.name = 'fiserveTdsForm';
  form.method = 'POST';
  var creqInput = document.createElement('input');
  creqInput.type = 'hidden';
  creqInput.name = 'creq';
  creqInput.value = action.threeds_challenge_action.challenge_request;
  form.appendChild(creqInput);

  if (!isNil(action.threeds_challenge_action.session_data)) {
    var sessionDataInput = document.createElement('input');
    sessionDataInput.type = 'hidden';
    sessionDataInput.name = 'sessionData';
    sessionDataInput.value = action.threeds_challenge_action.session_data;
    form.appendChild(sessionDataInput);
  }

  container.appendChild(iframe);
  container.appendChild(form);
  form.submit();
  return callbackPromise;
}
//# sourceMappingURL=fiserv-3ds-challenge-action-handler.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/payment/lib/esm/utilities/fiserv-3ds-challenge-action-handler.js
// module id = 600
// module chunks = 0 1